import layout from './WireframeView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import WireframeViewModel from '@/ViewModels/Views/WireframeViewModel';

export default class WireframeView extends View {
    protected view: JQuery<HTMLElement>;

    public constructor(protected viewModel: WireframeViewModel, protected element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('WireframeView', WireframeView, 'RADPresentation.HTMLClient.DefaultViewExtensions');